import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { callApi, getCookie, getInlineLoader, setCookie } from "../Helpers";
import {
  STR_APP_NAME,
  STR_CHANGE_LANGUAGE,
  STR_CHANGE_PHONE,
  STR_CONFIRM,
  STR_CONTINUE,
  STR_ENTER,
  STR_ENTER_OTP,
  STR_ENTER_YOUR_PHONE_NUMBER,
  STR_FORGOT_PASSWORD,
  STR_GET_STARTED,
  STR_HEALTH,
  STR_INTRO_1,
  STR_INTRO_2,
  STR_INTRO_22,
  STR_INVALID_CONFIRM_PASSWORD,
  STR_INVALID_OTP,
  STR_INVALID_PASSWORD,
  STR_INVALID_PHONE,
  STR_PASSWORD,
  STR_PLEASE_WAIT,
  STR_RELATIONSHIPS,
  STR_RESEND_OTP,
  STR_STORIES,
  STR_WELCOME
} from "../Strings";

import logo_icon from "../assets/logo_icon.png";
import logo_worded_only2 from "../assets/logo_worded_only2.png";

export default function Login(props) {

  const appContext = useContext(AppContext);

  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loginStep, setLoginStep] = useState("launch");

  async function init() {
    //..
  }

  async function getStarted() {
    appContext.navTo({
      item: 'view',
      subItem: 'login',
    })
  }

  useEffect(() => {
    init();
  }, [])

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [loading])

  return (
    <div className="Login bg-background">

      {
        (loginStep === 'launch') ?
          <div className="launch mNoScrollBar">

            {/* Mobile-first modern layout */}
            <div
              style={{
                width: "100%",
                minHeight: "100vh",
                position: "relative",
                overflow: "hidden",
                background: "var(--backgroundColor)",
                color: "var(--onBackgroundColor)",
              }}
            >

              {/* Decorative gradient blobs (simple + attractive) */}
              <div
                style={{
                  position: "absolute",
                  width: "360px",
                  height: "360px",
                  borderRadius: "360px",
                  top: "-120px",
                  left: "-120px",
                  background: "radial-gradient(circle at 30% 30%, rgba(11,111,182,0.35), rgba(11,111,182,0) 60%)",
                  pointerEvents: "none",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  width: "420px",
                  height: "420px",
                  borderRadius: "420px",
                  bottom: "-160px",
                  right: "-160px",
                  background: "radial-gradient(circle at 60% 40%, rgba(123,192,67,0.35), rgba(123,192,67,0) 60%)",
                  pointerEvents: "none",
                }}
              />

              {/* Content */}
              <div
                className="container"
                style={{
                  position: "relative",
                  zIndex: 2,
                  paddingTop: "26px",
                  paddingBottom: "26px",
                  height: "100%",
                }}
              >
                <div className="row" style={{ minHeight: "100vh" }}>

                  {/* Top brand section (mobile) / Left (desktop) */}
                  <div
                    className="col-md-6"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                    }}
                  >

                    {/* Modern logo badge */}
                    <div
                      className="mShadow3"
                      style={{
                        width: "86px",
                        height: "86px",
                        borderRadius: "26px",
                        background: "rgba(255,255,255,0.6)",
                        backdropFilter: "blur(10px)",
                        WebkitBackdropFilter: "blur(10px)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                        border: "1px solid rgba(0,0,0,0.06)",
                      }}
                    >
                      <img
                        src={logo_icon}
                        style={{
                          width: "54px",
                          height: "54px",
                          objectFit: "contain",
                        }}
                      />
                    </div>

                    {/* Wordmark */}
                    <div style={{ marginTop: "16px" }}>
                      <img
                        src={logo_worded_only2}
                        style={{
                          width: "210px",
                          height: "auto",
                        }}
                      />
                    </div>

                    {/* Tagline */}
                    <div
                      className="text-center"
                      style={{
                        marginTop: "14px",
                        maxWidth: "320px",
                      }}
                    >
                      <p
                        className="mNoMargin font-regular"
                        style={{
                          fontSize: "18px",
                          lineHeight: "20px",
                          opacity: 0.78,
                        }}
                      >
                        {STR_INTRO_2[appContext.language]}
                      </p>
                    </div>

                    

                  </div>

                  {/* Bottom actions (mobile) / Right (desktop) */}
                  <div
                    className="col-md-6"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      paddingTop: "18px",
                      paddingBottom: "28px",
                    }}
                  >
                    <div
                      className="card mShadow3"
                      style={{
                        width: "100%",
                        maxWidth: "420px",
                        borderRadius: "26px",
                        background: "rgba(244,244,244,0.78)",
                        backdropFilter: "blur(14px)",
                        WebkitBackdropFilter: "blur(14px)",
                        border: "1px solid rgba(0,0,0,0.06)",
                      }}
                    >
                      <div
                        style={{
                          padding: "18px",
                        }}
                      >
                        {/* Accent header line */}
                        <div
                          style={{
                            width: "100%",
                            height: "4px",
                            borderRadius: "10px",
                            background: "linear-gradient(90deg, var(--primaryColor), var(--secondaryColor))",
                            marginBottom: "14px",
                          }}
                        />

                        <h6
                          className="font-semi-bold mNoMargin"
                          style={{
                            fontSize: "16px",
                            marginBottom: "6px",
                            color: "var(--onSurfaceColor)",
                          }}
                        >
                          {STR_WELCOME[appContext.language]}
                        </h6>

                        <p
                          className="font-regular"
                          style={{
                            fontSize: "13px",
                            margin: 0,
                            opacity: 0.75,
                            lineHeight: "18px",
                          }}
                        >
                          {STR_INTRO_22[appContext.language]}
                        </p>

                        {/* Primary action */}
                        <button
                          className="btn btn-padded btn-block btn-primary btn-rounded"
                          style={{
                            marginTop: "18px",
                            textTransform: "capitalize",
                            fontSize: "14px",
                          }}
                          onClick={() => getStarted()}
                        >
                          {STR_GET_STARTED[appContext.language]}
                        </button>

                        {/* Secondary action */}
                        <button
                          className="btn btn-padded btn-block btn-outline-primary btn-rounded"
                          style={{
                            marginTop: "12px",
                            textTransform: "capitalize",
                            fontSize: "14px",
                          }}
                          onClick={() => appContext.changeLanguage()}
                        >
                          {(appContext.language === 'en') ? "Use Swahili" : "Use English"}
                        </button>

                        {/* Small footer note */}
                        <div className="text-center" style={{ marginTop: "14px" }}>
                          <p
                            className="mNoMargin font-regular"
                            style={{
                              fontSize: "12px",
                              opacity: 0.55,
                            }}
                          >
                            &copy;WOG (Women Of God)
                          </p>
                        </div>

                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div>

          </div>
          : ""
      }

    </div>
  )
}
